
import { booleanProp } from '@/mixins'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FrMessagePlaceholder',
  props: {
    sender: booleanProp(false)
  },
  setup() {
    return {}
  }
})
